import React from 'react'

const IcLogoutRed = (props) => <svg {...props} className="ic-detail" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="#F03B3B" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.6666 11.3334L14 8.00002L10.6666 4.66669" stroke="#F03B3B" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 8H6" stroke="#F03B3B" strokeLinecap="round" strokeLinejoin="round" />
</svg>

export default IcLogoutRed
